import 'css-chunksrc/client/scenes/workloads/graph/elementsOverlay/element/event/styles.scss';export default {
  "event": "_event_zz2oi_1",
  "element": "_element_zz2oi_7",
  "icon": "_icon_zz2oi_12",
  "hovered": "_hovered_zz2oi_21"
};